import React, { useState } from 'react';
import Banner from '../components/common/Banner';

const AcademicsPage = () => {
  const [activeSection, setActiveSection] = useState('courses');

  const courses = {
    btech: [
      { code: 'CE', name: 'Civil Engineering', description: 'Infrastructure development and construction technology' },
      { code: 'CSE', name: 'Computer Science & Engineering', description: 'Software development and computational technologies' },
      { code: 'ECE', name: 'Electronics & Communication Engineering', description: 'Electronics and communication systems' },
      { code: 'ME', name: 'Mechanical Engineering', description: 'Mechanical systems and manufacturing technology' }
    ],
    polytechnic: [
      { code: 'ECE', name: 'Electronics & Communication Engineering', description: 'Diploma in Electronics and Communication' },
      { code: 'ME', name: 'Mechanical Engineering', description: 'Diploma in Mechanical Engineering' }
    ]
  };

  const departments = [
    {
      id: 'ce',
      name: 'Department of Civil Engineering',
      description: 'The Civil Engineering department focuses on infrastructure development, construction technology, and sustainable engineering practices.',
      labs: ['Concrete Technology Lab', 'Surveying Lab', 'Geotechnical Engineering Lab', 'Environmental Engineering Lab', 'CAD Lab']
    },
    {
      id: 'cse',
      name: 'Department of Computer Science & Engineering',
      description: 'The CSE department emphasizes software development, artificial intelligence, and cutting-edge computational technologies.',
      labs: ['Programming Lab', 'Data Structures Lab', 'Database Management Lab', 'Network Security Lab', 'AI/ML Lab', 'Software Engineering Lab']
    },
    {
      id: 'ece',
      name: 'Department of Electronics & Communication Engineering',
      description: 'The ECE department covers electronics systems, communication technologies, and embedded systems design.',
      labs: ['Digital Electronics Lab', 'Communication Systems Lab', 'Microprocessor Lab', 'VLSI Design Lab', 'Signal Processing Lab']
    },
    {
      id: 'me',
      name: 'Department of Mechanical Engineering',
      description: 'The Mechanical Engineering department focuses on manufacturing, thermal systems, and mechanical design.',
      labs: ['Manufacturing Technology Lab', 'Thermal Engineering Lab', 'Fluid Mechanics Lab', 'Machine Design Lab', 'CAD/CAM Lab']
    }
  ];

  const antiRaggingActs = [
    'Any conduct by students that causes or is likely to cause physical or psychological harm',
    'Verbal abuse, threats, or intimidation of any form',
    'Forcing students to do any act which causes embarrassment, humiliation or psychological harm',
    'Any act of financial extortion or forceful expenditure',
    'Forcing students to perform tasks that are not related to academics',
    'Physical assault, sexual abuse or any form of misconduct',
    'Deliberate intent to cause mental harassment or create fear among junior students',
    'Any activity that disrupts the normal academic environment and student welfare'
  ];

  const renderCoursesSection = () => (
    <div className="space-y-8">
      <div className="mb-6 sm:mb-8">
        <h2 className="text-2xl sm:text-3xl font-serif font-bold text-slate mb-3 sm:mb-4">Courses Offered</h2>
        <p className="text-sm sm:text-base text-gray-500">Comprehensive engineering education programs designed for industry readiness.</p>
      </div>

      <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 lg:gap-8">
        {/* B.Tech Courses */}
        <div className="bg-white p-4 sm:p-6 rounded-xl border border-border_gray">
          <h3 className="text-lg sm:text-xl font-bold text-crimson mb-3 sm:mb-4 flex items-center">
            <i className="fas fa-graduation-cap mr-2"></i>
            Bachelor of Technology (B.Tech)
          </h3>
          <div className="space-y-4">
            {courses.btech.map((course, index) => (
              <div key={index} className="p-4 bg-surface rounded-lg border border-gray-200">
                <div className="flex justify-between items-start">
                  <div>
                    <h4 className="font-semibold text-slate">{course.name}</h4>
                    <p className="text-sm text-gray-500 mt-1">{course.description}</p>
                  </div>
                  <span className="bg-crimson text-white px-2 py-1 text-xs font-bold rounded">{course.code}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Polytechnic Courses */}
        <div className="bg-white p-4 sm:p-6 rounded-xl border border-border_gray">
          <h3 className="text-lg sm:text-xl font-bold text-crimson mb-3 sm:mb-4 flex items-center">
            <i className="fas fa-tools mr-2"></i>
            Polytechnic (Diploma)
          </h3>
          <div className="space-y-4">
            {courses.polytechnic.map((course, index) => (
              <div key={index} className="p-4 bg-surface rounded-lg border border-gray-200">
                <div className="flex justify-between items-start">
                  <div>
                    <h4 className="font-semibold text-slate">{course.name}</h4>
                    <p className="text-sm text-gray-500 mt-1">{course.description}</p>
                  </div>
                  <span className="bg-gold text-white px-2 py-1 text-xs font-bold rounded">{course.code}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  const renderDepartmentsSection = () => (
    <div className="space-y-8">
      <div className="mb-6 sm:mb-8">
        <h2 className="text-2xl sm:text-3xl font-serif font-bold text-slate mb-3 sm:mb-4">Departments</h2>
        <p className="text-sm sm:text-base text-gray-500">Specialized departments with state-of-the-art facilities and expert faculty.</p>
      </div>

      <div className="space-y-6">
        {departments.map((dept) => (
          <div key={dept.id} className="bg-white p-4 sm:p-6 md:p-8 rounded-xl border border-border_gray">
            <h3 className="text-lg sm:text-xl font-bold text-crimson mb-3 sm:mb-4">{dept.name}</h3>
            <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">{dept.description}</p>
            
            <div>
              <h4 className="font-semibold text-slate mb-3">Laboratory Facilities:</h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-3">
                {dept.labs.map((lab, index) => (
                  <div key={index} className="bg-surface px-3 py-2 rounded border border-gray-200 text-sm text-gray-700">
                    <i className="fas fa-flask text-crimson mr-2"></i>
                    {lab}
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const renderAntiRaggingSection = () => (
    <div className="space-y-8">
      <div className="mb-8">
        <h2 className="text-3xl font-serif font-bold text-slate mb-4">Anti-Ragging Policy</h2>
        <p className="text-gray-500">Creating a safe and conducive learning environment for all students.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        <div className="bg-white p-6 rounded-xl border border-border_gray">
          <h3 className="text-xl font-bold text-crimson mb-4">Acts that Constitute Ragging</h3>
          <ul className="space-y-3">
            {antiRaggingActs.map((act, index) => (
              <li key={index} className="flex items-start">
                <span className="bg-red-100 text-red-600 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold mr-3 mt-0.5">
                  {index + 1}
                </span>
                <span className="text-gray-600 text-sm">{act}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="bg-white p-6 rounded-xl border border-border_gray">
          <h3 className="text-xl font-bold text-crimson mb-4">Anti-Ragging Squad</h3>
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
            <div className="flex items-center text-yellow-800">
              <i className="fas fa-shield-alt text-yellow-600 mr-2"></i>
              <span className="font-semibold">24/7 Anti-Ragging Helpline</span>
            </div>
            <p className="text-yellow-700 text-sm mt-2">
              Students can report any incidents confidentially through our dedicated helpline.
            </p>
          </div>
          
          <div className="space-y-3">
            <p className="text-sm text-gray-600 font-semibold">Committee Members:</p>
            <div className="text-sm text-gray-500">
              <p>• Faculty Coordinator</p>
              <p>• Student Representatives</p>
              <p>• Administrative Staff</p>
              <p>• External Expert Members</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderGrievanceSection = () => (
    <div className="space-y-8">
      <div className="mb-8">
        <h2 className="text-3xl font-serif font-bold text-slate mb-4">Student Grievance</h2>
        <p className="text-gray-500">Submit your concerns and grievances through our online portal.</p>
      </div>

      <div className="max-w-2xl mx-auto bg-white p-8 rounded-xl border border-border_gray">
        <h3 className="text-xl font-bold text-crimson mb-6">Grievance Registration Form</h3>
        <form className="space-y-6">
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Full Name *</label>
              <input 
                type="text" 
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:border-crimson outline-none"
                placeholder="Enter your full name"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Student ID *</label>
              <input 
                type="text" 
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:border-crimson outline-none"
                placeholder="Enter student ID"
              />
            </div>
          </div>
          
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Email *</label>
              <input 
                type="email" 
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:border-crimson outline-none"
                placeholder="Enter email address"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Phone Number</label>
              <input 
                type="tel" 
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:border-crimson outline-none"
                placeholder="Enter phone number"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Department</label>
            <select className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:border-crimson outline-none">
              <option>Select Department</option>
              <option>Civil Engineering</option>
              <option>Computer Science & Engineering</option>
              <option>Electronics & Communication Engineering</option>
              <option>Mechanical Engineering</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Grievance Description * (Max 3000 characters)</label>
            <textarea 
              rows="6"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:border-crimson outline-none"
              placeholder="Please describe your grievance in detail..."
              maxLength="3000"
            ></textarea>
            <p className="text-xs text-gray-500 mt-1">Approximately 600 words maximum</p>
          </div>

          <div className="flex gap-4">
            <button 
              type="submit"
              className="bg-crimson hover:bg-red-800 text-white font-bold py-3 px-8 rounded-lg transition"
            >
              Submit Grievance
            </button>
            <button 
              type="reset"
              className="bg-gray-200 hover:bg-gray-300 text-gray-700 font-bold py-3 px-8 rounded-lg transition"
            >
              Reset Form
            </button>
          </div>
        </form>
      </div>
    </div>
  );

  const renderFacultyStaffSection = () => (
    <div className="space-y-8">
      <div className="mb-8">
        <h2 className="text-3xl font-serif font-bold text-slate mb-4">Faculty & Staff</h2>
        <p className="text-gray-500">Our commitment to excellence in engineering education.</p>
      </div>

      <div className="bg-white p-8 rounded-xl border border-border_gray">
        <div className="prose max-w-none text-gray-600">
          <h3 className="text-xl font-bold text-crimson mb-6">Excellence in Education</h3>
          
          <p className="mb-6">
            At Forte Institute of Technology, we pride ourselves on having a distinguished faculty and dedicated staff who are committed to nurturing the next generation of engineering professionals. Our academic community comprises experienced educators, industry experts, and passionate researchers who bring a wealth of knowledge and real-world experience to the classroom.
          </p>

          <h4 className="text-lg font-semibold text-slate mb-4">Faculty Excellence</h4>
          <p className="mb-6">
            Our faculty members hold advanced degrees from prestigious institutions across India and abroad. With an average teaching experience of over 15 years, they combine academic expertise with industry insights to deliver comprehensive education. The faculty-to-student ratio is maintained at an optimal level to ensure personalized attention and mentorship for every student.
          </p>

          <h4 className="text-lg font-semibold text-slate mb-4">Academic Leadership</h4>
          <p className="mb-6">
            The institute is led by visionary academic leaders who have decades of experience in engineering education and research. Our Principal, Vice Principal, and Deans work collaboratively to maintain high academic standards, implement innovative teaching methodologies, and foster a culture of continuous improvement.
          </p>

          <h4 className="text-lg font-semibold text-slate mb-4">Support Staff</h4>
          <p className="mb-6">
            Beyond our teaching faculty, we have a dedicated team of administrative and technical staff who ensure smooth functioning of all academic and co-curricular activities. From laboratory assistants to library staff, each member plays a crucial role in creating a conducive learning environment.
          </p>

          <h4 className="text-lg font-semibold text-slate mb-4">Professional Development</h4>
          <p className="mb-6">
            We believe in continuous learning and regularly organize faculty development programs, workshops, and conferences. Our faculty members are encouraged to pursue research, publish papers, and participate in national and international academic forums. This ensures they stay updated with the latest technological advancements and pedagogical innovations.
          </p>

          <h4 className="text-lg font-semibold text-slate mb-4">Student-Centric Approach</h4>
          <p className="mb-6">
            Every member of our faculty and staff is committed to student success. We maintain an open-door policy where students can approach faculty members for academic guidance, career counseling, or personal mentorship. Regular feedback mechanisms ensure that teaching methods are continuously refined to meet student needs.
          </p>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mt-8">
            <h4 className="text-lg font-bold text-blue-800 mb-4 flex items-center">
              <i className="fas fa-envelope text-blue-600 mr-2"></i>
              Contact Information
            </h4>
            <div className="grid md:grid-cols-2 gap-6 text-sm">
              <div>
                <p className="text-blue-700 font-semibold mb-2">Academic Inquiries</p>
                <p className="text-blue-600">📧 academics@fit.ac.in</p>
                <p className="text-blue-600">📞 +91 98765-43200</p>
                <p className="text-blue-600 mt-2">Office Hours: Mon-Fri, 9:00 AM - 5:00 PM</p>
              </div>
              <div>
                <p className="text-blue-700 font-semibold mb-2">Administrative Office</p>
                <p className="text-blue-600">📧 info@fit.ac.in</p>
                <p className="text-blue-600">📞 +91 98765-43201</p>
                <p className="text-blue-600 mt-2">Office Hours: Mon-Sat, 8:30 AM - 4:30 PM</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const sections = [
    { id: 'courses', label: 'Courses Offered', component: renderCoursesSection },
    { id: 'departments', label: 'Departments', component: renderDepartmentsSection },
    { id: 'anti-ragging', label: 'Anti-Ragging', component: renderAntiRaggingSection },
    { id: 'grievance', label: 'Grievance', component: renderGrievanceSection },
    { id: 'faculty-staff', label: 'Faculty & Staff', component: renderFacultyStaffSection }
  ];

  return (
    <div className="h-full w-full  fade-in">
      <Banner 
        title="Academics"
        subtitle="Comprehensive Engineering Programs | Building Future Innovators"
        imageSrc="https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80"
      />
      <div className="max-w-6xl mx-auto p-4 sm:p-6 md:p-10">
        
        {/* Section Navigation */}
        <div className="mb-6 sm:mb-8 border-b border-gray-200">
          <div className="flex space-x-4 sm:space-x-8 overflow-x-auto scrollbar-hide">
            {sections.map((section) => (
              <button
                key={section.id}
                onClick={() => setActiveSection(section.id)}
                className={`py-3 sm:py-4 px-1 sm:px-2 border-b-2 text-sm sm:text-base font-semibold whitespace-nowrap transition-all ${
                  activeSection === section.id
                    ? 'border-crimson text-crimson'
                    : 'border-transparent text-gray-500 hover:text-gray-700'
                }`}
              >
                {section.label}
              </button>
            ))}
          </div>
        </div>

        {/* Active Section Content */}
        {sections.find(section => section.id === activeSection)?.component()}

      </div>
    </div>
  );
};

export default AcademicsPage;